
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface EmptySubmissionsProps {
  statusFilter: 'all' | 'pending' | 'approved' | 'rejected';
}

const EmptySubmissions = ({ statusFilter }: EmptySubmissionsProps) => {
  return (
    <Card>
      <CardContent className="text-center py-8">
        <p className="text-muted-foreground mb-4">
          {statusFilter === 'all' 
            ? "You haven't submitted any terraces yet." 
            : `No ${statusFilter} submissions found.`}
        </p>
        <Button asChild>
          <Link to="/submit-terrace">Submit Your First Terrace</Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default EmptySubmissions;
